import { memo } from "react";

import { Switcher, TextSwitcherItem } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { generateAutomationName } from "../../../helpers/generateAutomationName";

import { StyledSwitch } from "./styles";

type GranularitySwitchSchema = {
    selectedIndex: number;
    onClick(granId: number): void;
    granularities: Record<string, string>;
    dataAutomation?: string;
};

const GranularitySwitch = memo(({ selectedIndex, onClick, granularities, dataAutomation }: GranularitySwitchSchema) => (
    <StyledSwitch data-automation={dataAutomation}>
        <Switcher
            selectedIndex={selectedIndex}
            onItemClick={onClick}
        >
            {Object.keys(granularities).map((granularity) => (
                <TextSwitcherItem key={granularity}>
                    <span data-automation={generateAutomationName("granularitySwitch", [granularity])}>
                        {translate(granularities[granularity])}
                    </span>
                </TextSwitcherItem>
            ))}
        </Switcher>
    </StyledSwitch>
));

GranularitySwitch.displayName = "GranularitySwitch";
export default GranularitySwitch;
